module.exports = {
  INSURANCE: 'insurance',
  MILEAGE: 'mileage',
  EQUIPMENT: 'equipment',
  SERVICE: 'service',
  WASHING: 'washing',
  VALET: 'valet', // Voiturier
  TARP: 'tarp', // bâchage
  INVENTORY: 'inventory', // état des lieux
  FEE: 'fee',
  OTHER: 'other',
};
